import HttpClient from './http-client';
import URL from './url';

export default class ExamPrepKitV2Api {

    static getBaselineAssessmentStatus(payload) {
        let url = URL.BASE_URL + URL.BASELINE_STATUS;

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                if (payload[key] !== undefined && payload[key] !== null) {
                    params.push(`${key}=${encodeURIComponent(payload[key])}`);
                }
            });
        }

        if (params && params.length) {
            url = url + "?" + params.join('&');
        }

        return HttpClient.get(url);
    }

    static startBaselineAssessment(payload) {
        return HttpClient.post(URL.BASE_URL + URL.BASELINE_START, null, payload);
    }

    static getPracticeMoreStatus(payload) {
        let url = URL.BASE_URL + URL.EXAM_PREP_KIT_PRACTICE_MORE;

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                if (payload[key] !== undefined && payload[key] !== null) {
                    params.push(`${key}=${encodeURIComponent(payload[key])}`);
                }
            });
        }

        if (params && params.length) {
            url = url + "?" + params.join('&');
        }

        return HttpClient.get(url);
    }

    static getFinishlineAssessmentStatus(payload) {
        let url = URL.BASE_URL + URL.FINISHLINE_STATUS;

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                if (payload[key] !== undefined && payload[key] !== null) {
                    params.push(`${key}=${encodeURIComponent(payload[key])}`);
                }
            });
        }

        if (params && params.length) {
            url = url + "?" + params.join('&');
        }

        return HttpClient.get(url);
    }

    static startFinishlineAssessment(payload) {
        return HttpClient.post(URL.BASE_URL + URL.FINISHLINE_START, null, payload);
    }

    /**
     * Fetches the pdf_kit_activity document for a student + chapterKey.
     * If no document exists yet, the backend auto-creates one with all sections
     * at { isCompleted: false, percentage: 0 } and returns it (upsert-with-defaults).
     */
    static getPdfKitActivity(payload) {
        let url = URL.BASE_URL + URL.PDF_KIT_ACTIVITY;

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                if (payload[key] !== undefined && payload[key] !== null) {
                    params.push(`${key}=${encodeURIComponent(payload[key])}`);
                }
            });
        }

        if (params && params.length) {
            url = url + '?' + params.join('&');
        }

        return HttpClient.get(url);
    }

    /**
     * Updates or marks a section as completed in the pdf_kit_activity collection.
     */
    static updatePdfKitActivity(payload) {
        return HttpClient.post(URL.BASE_URL + URL.PDF_KIT_ACTIVITY, null, payload);
    }
}
